module.exports = new __parcel__URL__("youtube-icon.e5306d40.svg").toString();